/* Spin — storefront behaviour.
   Ported from the pitch mockup: cart drawer, quick add, hero slider,
   search overlay, mobile menu, PDP gallery + variants. No dependencies. */
(function () {
  'use strict';

  var R = window.Spin.routes;
  var S = window.Spin.strings;
  var $ = function (s, c) { return (c || document).querySelector(s); };
  var $$ = function (s, c) { return Array.prototype.slice.call((c || document).querySelectorAll(s)); };

  /* ---------------- toast ---------------- */
  var toastEl = $('#toast');
  var toastTimer;
  function toast(msg) {
    if (!toastEl) return;
    toastEl.textContent = msg;
    toastEl.classList.add('on');
    clearTimeout(toastTimer);
    toastTimer = setTimeout(function () { toastEl.classList.remove('on'); }, 2200);
  }

  /* ---------------- overlays ---------------- */
  var scrim = $('#scrim');
  var drawer = $('#cartDrawer');
  var search = $('#search');
  var mmenu = $('#mmenu');

  function closeAll() {
    [drawer, search, mmenu].forEach(function (el) { if (el) el.classList.remove('on'); });
    if (scrim) scrim.classList.remove('on');
    document.body.classList.remove('no-scroll');
    ['#cartBtn', '#searchBtn', '#burger'].forEach(function (s) {
      var b = $(s); if (b) b.setAttribute('aria-expanded', 'false');
    });
  }
  function open(el, btnSel) {
    closeAll();
    if (el) el.classList.add('on');
    if (scrim) scrim.classList.add('on');
    document.body.classList.add('no-scroll');
    var b = btnSel && $(btnSel);
    if (b) b.setAttribute('aria-expanded', 'true');
  }

  if (scrim) scrim.addEventListener('click', closeAll);
  document.addEventListener('keydown', function (e) { if (e.key === 'Escape') closeAll(); });

  var cartBtn = $('#cartBtn');
  if (cartBtn) cartBtn.addEventListener('click', function () { open(drawer, '#cartBtn'); });
  var cartClose = $('#cartClose');
  if (cartClose) cartClose.addEventListener('click', closeAll);

  var burger = $('#burger');
  if (burger) burger.addEventListener('click', function () { open(mmenu, '#burger'); });
  var mmenuClose = $('#mmenuClose');
  if (mmenuClose) mmenuClose.addEventListener('click', closeAll);

  var searchBtn = $('#searchBtn');
  var searchInput = $('#searchInput');
  if (searchBtn) {
    searchBtn.addEventListener('click', function () {
      open(search, '#searchBtn');
      setTimeout(function () { if (searchInput) searchInput.focus(); }, 220);
    });
  }
  var searchClose = $('#searchClose');
  if (searchClose) searchClose.addEventListener('click', closeAll);

  /* ---------------- cart ---------------- */
  function refreshCart(openDrawer) {
    return fetch(R.cart + '?section_id=cart-fragments', { headers: { 'X-Requested-With': 'XMLHttpRequest' } })
      .then(function (r) { return r.text(); })
      .then(function (html) {
        var doc = new DOMParser().parseFromString(html, 'text/html');
        var body = doc.querySelector('[data-cart-body]');
        var foot = doc.querySelector('[data-cart-foot]');
        var count = doc.querySelector('[data-cart-count]');
        if (body) $('#cartBody').innerHTML = body.innerHTML;
        if (foot) $('#cartFoot').innerHTML = foot.innerHTML;
        if (count) {
          var n = parseInt(count.textContent.trim(), 10) || 0;
          var el = $('#cartCount');
          if (el) { el.textContent = n; el.classList.toggle('on', n > 0); }
        }
        if (openDrawer) open(drawer, '#cartBtn');
      });
  }

  function addToCart(id, qty) {
    return fetch(R.cart_add, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ items: [{ id: id, quantity: qty || 1 }] })
    })
      .then(function (r) { return r.json().then(function (d) { return { ok: r.ok, data: d }; }); })
      .then(function (res) {
        if (!res.ok) { toast(res.data.description || res.data.message || S.soldOut); return; }
        toast(S.added);
        return refreshCart(true);
      })
      .catch(function () { toast(S.soldOut); });
  }

  function changeLine(key, qty) {
    return fetch(R.cart_change, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ id: key, quantity: qty })
    }).then(function () {
      // the standalone cart page needs its own lines redrawn, so reload there
      if (document.body.classList.contains('template-cart')) { window.location.reload(); return; }
      return refreshCart(false);
    });
  }

  document.addEventListener('click', function (e) {
    var add = e.target.closest('[data-add]');
    if (add) {
      e.preventDefault();
      var qty = parseInt(add.getAttribute('data-qty'), 10) || 1;
      addToCart(add.getAttribute('data-add'), qty);
      return;
    }
    var line = e.target.closest('[data-line-change]');
    if (line) {
      e.preventDefault();
      changeLine(line.getAttribute('data-line-change'), parseInt(line.getAttribute('data-qty'), 10));
    }
  });

  /* PDP add to cart, submitted over fetch so the drawer can open */
  var pdpForm = $('#pdpForm');
  if (pdpForm) {
    pdpForm.addEventListener('submit', function (e) {
      e.preventDefault();
      var fd = new FormData(pdpForm);
      fetch(R.cart_add, { method: 'POST', headers: { Accept: 'application/json' }, body: fd })
        .then(function (r) { return r.json().then(function (d) { return { ok: r.ok, data: d }; }); })
        .then(function (res) {
          if (!res.ok) { toast(res.data.description || res.data.message || S.soldOut); return; }
          toast(S.added);
          return refreshCart(true);
        })
        .catch(function () { toast(S.soldOut); });
    });
  }

  /* ---------------- quantity stepper ---------------- */
  document.addEventListener('click', function (e) {
    var b = e.target.closest('[data-q]');
    if (!b) return;
    var wrap = b.closest('.qtyrow') || document;
    var val = $('#qtyVal', wrap) || $('#qtyVal');
    var input = $('#qtyInput', wrap) || $('#qtyInput');
    if (!val) return;
    var n = Math.max(1, (parseInt(val.textContent, 10) || 1) + parseInt(b.getAttribute('data-q'), 10));
    val.textContent = n;
    if (input) input.value = n;
  });

  /* ---------------- PDP gallery ----------------
     Main shot with side arrows over a thumbnail row, advancing on its own.
     The image element is looked up inside #mainshot rather than by its own
     id: image_tag does not reliably pass an id through. */
  (function () {
    var box = $('#mainshot');
    var thumbs = $$('.thumbs button');
    if (!box || thumbs.length === 0) return;

    var i = 0;
    var timer = null;
    var delay = parseInt(box.getAttribute('data-autoplay'), 10) || 0;
    var reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

    function show(n) {
      i = (n + thumbs.length) % thumbs.length;
      thumbs.forEach(function (b, k) {
        b.classList.toggle('on', k === i);
        if (k === i) { b.setAttribute('aria-current', 'true'); }
        else { b.removeAttribute('aria-current'); }
      });
      var img = box.querySelector('img');
      var btn = thumbs[i];
      if (!img) return;

      var nextSrc = btn.getAttribute('data-full');
      var nextSet = btn.getAttribute('data-srcset') || '';
      if (!nextSrc || nextSrc === img.getAttribute('src')) return;

      // preload first, so the fade never lands on a blank frame
      var pre = new Image();
      if (nextSet) pre.srcset = nextSet;
      pre.onload = pre.onerror = function () {
        img.style.opacity = '0';
        setTimeout(function () {
          // srcset wins over src, so clear it or the browser keeps the old pick
          img.srcset = nextSet;
          img.src = nextSrc;
          img.style.opacity = '';
        }, 320);
      };
      pre.src = nextSrc;
    }

    function start() {
      if (!delay || reduce || thumbs.length < 2) return;
      stop();
      timer = setInterval(function () { show(i + 1); }, delay);
    }
    function stop() { if (timer) { clearInterval(timer); timer = null; } }
    function jump(n) { stop(); show(n); start(); }

    thumbs.forEach(function (btn, k) {
      btn.addEventListener('click', function () { jump(k); });
    });

    var prev = $('.gnav.prev', box);
    var next = $('.gnav.next', box);
    if (prev) prev.addEventListener('click', function () { jump(i - 1); });
    if (next) next.addEventListener('click', function () { jump(i + 1); });

    // hold still while someone is actually looking at it
    box.addEventListener('mouseenter', stop);
    box.addEventListener('mouseleave', start);
    box.addEventListener('focusin', stop);

    // and while the tab is in the background
    document.addEventListener('visibilitychange', function () {
      if (document.hidden) { stop(); } else { start(); }
    });

    var gal = $('.gal');
    if (gal) {
      gal.addEventListener('keydown', function (e) {
        if (e.key === 'ArrowLeft') { e.preventDefault(); jump(i - 1); }
        if (e.key === 'ArrowRight') { e.preventDefault(); jump(i + 1); }
      });
    }

    /* full-size viewer */
    var lb = $('#lightbox');
    if (lb) {
      var lbImg = $('#lbImg', lb);
      var lbNow = $('#lbNow', lb);
      var zooms = (box.getAttribute('data-zoom-urls') || '').split('|').filter(Boolean);
      var z = 0;

      function paint() {
        if (!zooms[z]) return;
        lbImg.src = zooms[z];
        if (lbNow) lbNow.textContent = z + 1;
      }
      function openLb(n) {
        z = (n + zooms.length) % zooms.length;
        paint();
        lb.hidden = false;
        requestAnimationFrame(function () { lb.classList.add('on'); });
        document.body.classList.add('no-scroll');
        stop();
      }
      function closeLb() {
        lb.classList.remove('on');
        document.body.classList.remove('no-scroll');
        setTimeout(function () { lb.hidden = true; }, 280);
        show(z);      // keep the inline gallery on whatever was last viewed
        start();
      }
      function stepLb(d) { z = (z + d + zooms.length) % zooms.length; paint(); }

      box.addEventListener('click', function (e) {
        if (e.target.closest('.gnav')) return;   // arrows are not a zoom target
        openLb(i);
      });

      $('.lb-close', lb).addEventListener('click', closeLb);
      lb.addEventListener('click', function (e) {
        if (e.target === lb || e.target === lbImg) closeLb();
      });
      var lp = $('.lb-nav.prev', lb), ln = $('.lb-nav.next', lb);
      if (lp) lp.addEventListener('click', function (e) { e.stopPropagation(); stepLb(-1); });
      if (ln) ln.addEventListener('click', function (e) { e.stopPropagation(); stepLb(1); });

      document.addEventListener('keydown', function (e) {
        if (lb.hidden) return;
        if (e.key === 'Escape') closeLb();
        if (e.key === 'ArrowLeft') stepLb(-1);
        if (e.key === 'ArrowRight') stepLb(1);
      });
    }

    start();
  })();

  /* ---------------- variant picker ---------------- */
  var vSelect = $('#variantSelect');
  if (vSelect) {
    $$('.vopts input').forEach(function (input) {
      input.addEventListener('change', function () {
        var chosen = $$('.vgroup').map(function (g) {
          var c = $('input:checked', g);
          return c ? c.value : null;
        });
        var match = null;
        $$('#variantSelect option').forEach(function (opt) {
          var title = opt.textContent.trim();
          if (title === chosen.join(' / ')) match = opt;
        });
        if (!match) return;
        vSelect.value = match.value;
        var price = $('#pdpPrice');
        if (price) {
          var compare = match.getAttribute('data-compare');
          price.innerHTML = (compare ? '<span class="was">' + compare + '</span>' : '') + match.getAttribute('data-price');
        }
        var addBtn = $('#addBtn');
        if (addBtn) {
          if (!addBtn.dataset.label) addBtn.dataset.label = addBtn.textContent.trim();
          addBtn.disabled = match.disabled;
          addBtn.textContent = match.disabled ? S.soldOut : addBtn.dataset.label;
        }
        var url = new URL(window.location.href);
        url.searchParams.set('variant', match.value);
        window.history.replaceState({}, '', url);
      });
    });
  }

  /* ---------------- hero slider ---------------- */
  var hero = $('#hero');
  if (hero) {
    var slides = $$('.slide', hero);
    var dots = $$('#heroDots i');
    var title = $('#heroT');
    var i = 0;
    var timer = null;
    var interval = parseInt(hero.getAttribute('data-interval'), 10) || 6000;

    function go(n) {
      i = (n + slides.length) % slides.length;
      slides.forEach(function (s, k) { s.classList.toggle('on', k === i); });
      dots.forEach(function (d, k) { d.classList.toggle('on', k === i); });
      if (title) {
        title.style.opacity = 0;
        setTimeout(function () {
          title.textContent = slides[i].getAttribute('data-heading') || '';
          title.style.opacity = 1;
        }, 200);
      }
    }
    function start() { if (slides.length > 1) timer = setInterval(function () { go(i + 1); }, interval); }
    function stop() { clearInterval(timer); }

    dots.forEach(function (d) {
      d.addEventListener('click', function () { stop(); go(parseInt(d.getAttribute('data-slide'), 10)); start(); });
      d.addEventListener('keydown', function (e) {
        if (e.key === 'Enter' || e.key === ' ') { e.preventDefault(); d.click(); }
      });
    });
    hero.addEventListener('mouseenter', stop);
    hero.addEventListener('mouseleave', start);
    if (!window.matchMedia('(prefers-reduced-motion: reduce)').matches) start();
  }

  /* ---------------- predictive search ---------------- */
  var results = $('#searchRes');
  if (searchInput && results) {
    var t = null;
    searchInput.addEventListener('input', function () {
      var q = searchInput.value.trim();
      clearTimeout(t);
      if (q.length < 2) { results.innerHTML = ''; return; }
      t = setTimeout(function () {
        fetch(R.predictive + '?q=' + encodeURIComponent(q) + '&resources[type]=product&resources[limit]=8&section_id=predictive-search')
          .then(function (r) { return r.text(); })
          .then(function (html) {
            var doc = new DOMParser().parseFromString(html, 'text/html');
            var box = doc.querySelector('[data-predictive]');
            results.innerHTML = box ? box.innerHTML : '';
          })
          .catch(function () { results.innerHTML = ''; });
      }, 220);
    });
  }

  /* ---------------- collection discs: a random product shot ----------------
     Each disc carries a pool of real product photos. Pages are cached, so the
     pick has to happen in the browser for it to actually vary per visit. */
  (function () {
    var discs = $$('.col-tile .disc[data-pool]');
    if (discs.length === 0) return;

    discs.forEach(function (disc) {
      var pool = (disc.getAttribute('data-pool') || '').split('||').filter(Boolean);
      if (pool.length === 0) return;

      var pick = pool[Math.floor(Math.random() * pool.length)].split('~~');
      var src = pick[0], bg = pick[1], full = pick[2] === '1';
      if (!src) return;

      var img = disc.querySelector('img');
      if (!img) return;

      img.removeAttribute('srcset');   // or the browser keeps its own pick
      img.src = src;
      if (bg) disc.style.background = bg;
      disc.classList.toggle('full', full);
    });
  })();

  /* ---------------- view as: 3 or 4 per row ---------------- */
  (function () {
    var grid = $('#pgrid');
    var btns = $$('.va');
    if (!grid || btns.length === 0) return;

    var KEY = 'spin:cols';

    function apply(n, remember) {
      grid.classList.remove('cols-3', 'cols-4');
      grid.classList.add('cols-' + n);
      btns.forEach(function (b) {
        var on = b.getAttribute('data-cols') === String(n);
        b.classList.toggle('on', on);
        b.setAttribute('aria-pressed', on ? 'true' : 'false');
      });
      if (remember) {
        try { localStorage.setItem(KEY, n); } catch (e) {}
      }
    }

    var saved;
    try { saved = localStorage.getItem(KEY); } catch (e) {}
    apply(saved === '4' ? 4 : 3, false);

    btns.forEach(function (b) {
      b.addEventListener('click', function () { apply(b.getAttribute('data-cols'), true); });
    });
  })();

  /* ---------------- collection sort ---------------- */
  var sortSel = $('#sortSel');
  if (sortSel) sortSel.addEventListener('change', function () { $('#sortForm').submit(); });

  /* ---------------- scroll reveals ----------------
     Nothing is tagged in Liquid. Elements are found here and marked, so any
     section a merchant adds in the customizer later is picked up for free. */
  (function () {
    if (!('IntersectionObserver' in window)) return;
    if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;

    var SKIP = '.hero, .drawer, .srch, .mmenu, #toast';
    var STAGGER_CAP = 7;

    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (!entry.isIntersecting) return;
        entry.target.classList.add('in');
        io.unobserve(entry.target);
      });
    }, { rootMargin: '0px 0px -6% 0px', threshold: 0.04 });

    function mark(el, delay) {
      if (!el || el.hasAttribute('data-reveal')) return;
      if (el.closest(SKIP)) return;
      el.setAttribute('data-reveal', '');
      if (delay) el.style.setProperty('--d', delay + 'ms');
      io.observe(el);
    }

    [['.pgrid', '.card', 70],
     ['.cols', '.col-tile', 70],
     ['.revs', '.rev', 90],
     ['.ft-grid', 'div', 100],
     ['.prose', '*', 55],
     ['.artgrid', '.artcard', 60]
    ].forEach(function (group) {
      $$(group[0]).forEach(function (parent) {
        var i = 0;
        Array.prototype.forEach.call(parent.children, function (child) {
          if (!child.matches(group[1])) return;
          mark(child, Math.min(i, STAGGER_CAP) * group[2]);
          i++;
        });
      });
    });

    ['.shead', '.cbanner', '.pagehead', '.split .im', '.feature .plate', '.feature .cap',
     '.glowsec .shot', '.glowsec .scroll-mark', '.glowsec .in > div',
     '.pdp .gal', '.pdp .info', '.filters', '.notfound', '.acc', '.share'
    ].forEach(function (sel) { $$(sel).forEach(function (el) { mark(el, 0); }); });

    $$('.brush').forEach(function (el) { mark(el, 150); });

    document.documentElement.classList.add('js-reveal');
  })();
})();
